(() => {
	const ClientsController = (
		$scope,
		$rootScope,
		$location,
		$routeParams,
		authTokensService,
		clientsDataService,
		messageService,
		validationService,
		templateRequestsService,
		mailsDataService,
		emailService,
		fileDownloadDataService,
		settingsService
	) => {
		$scope.$on('$viewContentLoaded', () => {
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'id',
					reverse: true
				},
				search: ''
			};
			$scope.jobs = [];
			$scope.totalItems = 0;
			$scope.searchText = '';
			$scope.pageRequest.search = null;
			$scope.initImportClientsDropzone();

			$scope.isDeleteContactSpinnningWheelActive = false;
			$scope.isCreateClientModalSpinnningWheelActive = false;
			$scope.isExportingClientsWheelActive = false;
			$scope.lastCalledSendEmailFn = null;
			$scope.clientToSendMail = null;
			$scope.unsubscribe = new Rx.Subject();

			subscribeToCustomizeLabelsChange();
		});

		$scope.$on('$destroy', () => {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable
				.takeUntil($scope.unsubscribe)
				.subscribe(customizeLabels => {
					$scope.mainShootLabelName = customizeLabels.mainShootLabel;
					$scope.extraShootLabelName = customizeLabels.extraShootLabel;
					$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				});
		}

		const csvErrorCases = [
			{
				errorCode: 'e_2',
				errorMessage: 'Your CSV file is empty'
			},
			{
				errorCode: 'e_3',
				errorMessage: 'first name can not be empty.'
			},
			{
				errorCode: 'e_3',
				errorMessage: 'FirstName column is empty'
			},
			{
				errorCode: 'e_4',
				errorMessage: 'email can not be empty.'
			},
			{
				errorCode: 'e_4',
				errorMessage: 'Email column is empty'
			},
			{
				errorCode: 'e_5',
				errorMessage: 'Multiple contact with same email in CSV'
			},
			{
				errorCode: 'e_6',
				errorMessage: 'already registered!'
			},
			{
				errorCode: 'e_8',
				errorMessage: 'column is not exist in CSV'
			}
		];

		$scope.downloadCSVTemplate = function() {
			const csvTemplateName = 'import_clients_template.csv';
			const csvTemplateContent =
				'first name, last name, phone, email, street address, suburb/town, postcode/zip, state, country';
			const element = document.createElement('a');

			element.setAttribute(
				'href',
				`data:text/csv;charset=utf-8,${encodeURIComponent(csvTemplateContent)}`
			);
			element.setAttribute('download', csvTemplateName);
			element.style.display = 'none';
			document.body.appendChild(element);
			element.click();
			document.body.removeChild(element);
		};
		$scope.openImportClientsModal = () => {
			$('#import-clients-modal').modal('show');
		};

		$scope.initImportClientsDropzone = () => {
			$('#import-clients-dropzone').dropzone({
				url: '/protected/rest/clients/import-clients',
				paramName: 'csvFile',
				acceptedFiles: '.csv',
				maxFiles: 1,
				parallelUploads: 1,
				uploadMultiple: false,
				timeout: 0,
				headers: {
					Authorization: `Bearer ${authTokensService.getAuthToken()}`
				},
				init() {
					this.on('maxfilesexceeded', function(file) {
						this.removeAllFiles();
						this.addFile(file);
					});
					this.on('addedfile', function(file) {
						if (file.name.split('.').pop() !== 'csv') {
							this.removeFile(file);
							messageService.showToaster('e_1', 'csvFiles');
						} else {
							this.processQueue();
							this.processFile(file);
						}
					});
					this.on('sending', () => {
						$scope.disableDropzone = true;
					});
					this.on('success', function(file, response) {
						$scope.disableDropzone = false;
						this.removeFile(file);
						this.removeAllFiles();
						if (response.errorMessage) {
							toastr.error(response.errorMessage, 'Error');
						} else {
							$('#import-clients-modal').modal('hide');
							getResultsPage(
								$scope.pageRequest.page,
								$scope.pageRequest.perPage
							);
							messageService.showToaster('s_0', 'csvFiles');
						}
					});
					this.on('error', function(file, data) {
						$scope.disableDropzone = false;
						this.removeFile(file);
						this.removeAllFiles();
						if (data.error && data.error === 'invalid_token') {
							messageService.showToaster(
								'e_2',
								'general',
								'Please refresh page and try again'
							);
						} else if (data.errorMessage) {
							handleCsvErrors(data.errorMessage);
						}
					});
				}
			});
		};
		function handleCsvErrors(receivedError) {
			if (!receivedError) {
				console.info('No error messages');
				return;
			}

			const foundError = csvErrorCases.find(error =>
				receivedError.includes(error.errorMessage)
			);

			// 'e_7' === "That's not a Studio Ninja CSV file!"
			const errorCode = foundError ? foundError.errorCode : 'e_7';

			messageService.showToaster(errorCode, 'csvFiles');
		}

		function searchRequest() {
			$scope.pageRequest.search = $scope.searchText;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		}

		$scope.showClient = function(id) {
			$location.path(`/clients/client${id}`);
		};

		$scope.retrySendMail = function() {
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			emailService.callLastEmailFn();
		};

		$scope.openSendMailModal = function(contact) {
			delete $scope.mailData2Save;
			delete $scope.clientMailData;
			$scope.button_disable = true;

			Rx.Observable.zip(
				templateRequestsService.getTemplates('general_preview'),
				templateRequestsService.getTemplates('email_signature')
			)
				.takeUntil($scope.unsubscribe)
				.finally(() => ($scope.button_disable = false))
				.subscribe(([emails, mailSignature]) => {
					$scope.mailData2Save = angular.copy(contact);
					$scope.mailData2Save.emails = emails;
					$scope.mailData2Save.mailSignature = mailSignature.signature || '';
					$rootScope.clientToken = false;

					if (!$scope.$$phase) {
						$scope.$apply();
					}

					$('#sendContactEmailModal').modal('show');
				});
		};
		$scope.sendMail = function() {
			prepareEmailText();
			$scope.disableBtnOnSend = true;

			mailsDataService
				.sendEmail(
					$rootScope.sendMessage,
					$scope.contactForSending.id,
					$routeParams.jobId,
					$routeParams.jobId
				)
				.finally(() => {
					$scope.disableBtnOnSend = false;
				})
				.subscribe(() => successMailSend());
		};

		function prepareEmailText() {
			let _emailText = '';

			if (!$rootScope.sendMessage.emailText) {
				_emailText = $('.in .textarea-quad textarea')[0].value;
			} else {
				_emailText = $rootScope.sendMessage.emailText;
			}
			$rootScope.sendMessage.emailText = $rootScope.addMaiStyling(_emailText);
		}

		function successMailSend() {
			if ($rootScope.updateJobView) {
				$rootScope.updateJobView();
			} else if ($rootScope.updateLeadView) {
				$rootScope.updateLeadView();
			}
			for (const prop in $rootScope.sendMessage) {
				$rootScope.sendMessage[prop] = '';
			}

			toastr.success('Mail sent!', 'Success');
			$('#sendContactEmailModal').modal('hide');
		}

		let timerId;

		$scope.$watch('searchText', newValue => {
			if (newValue != null) {
				if (newValue.length > 0) {
					if (timerId != null) {
						clearTimeout(timerId);
					}
					timerId = setTimeout(searchRequest, 500);
				} else {
					clearTimeout(timerId);
					if (newValue.length == 0) {
						$scope.pageRequest.search = '';
						getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
					}
				}
			}
		});

		$scope.downloadClients = function() {
			$scope.isExportingClientsWheelActive = true;
			fileDownloadDataService
				.saveClients()
				.then(() => ($scope.isExportingClientsWheelActive = false))
				.catch(({ error }) => {
					const { errorTitle, errorMessage } = error;
					messageService.showErrorFromBackend(errorTitle, errorMessage);
					$scope.isExportingClientsWheelActive = false;
				});
		};

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};

		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};

		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.createNewClient = () => {
			delete $scope.client;
			$('#createNewClientModal').modal('show');
		};

		$scope.editClient = index => {
			$scope.button_disable = true;
			$scope.client = angular.copy($scope.contacts[index]);
			$scope.companyNameChecked =
				!!$scope.client.companyName || !!$scope.client.businessNumber;
			$('#createNewClientModal').modal('show');
			$scope.button_disable = false;
		};

		$scope.save = updateId => {
			$scope.isCreateClientModalSpinnningWheelActive = true;
			if (validationService.isStringEmpty($scope.client.firstName)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_4', 'clients');
			}

			if (!validationService.isEmailValid($scope.client.email)) {
				$scope.isCreateClientModalSpinnningWheelActive = false;
				return messageService.showToaster('e_3', 'companyUsers');
			}

			if (!$scope.companyNameChecked && $scope.client) {
				delete $scope.client.companyName;
				delete $scope.client.businessNumber;
			}

			if ($scope.client.notes) {
				$scope.client.notes =
					$rootScope.addMaiStyling($scope.client.notes) || null;
			}

			if (updateId) {
				clientsDataService
					.updateClient($scope.client)
					.subscribe(
						data => successUpdateClient(data),
						error => errorAddClient(error.data),
						() => ($scope.isCreateClientModalSpinnningWheelActive = false)
					);
			} else if ($scope.client) {
				clientsDataService
					.addNewClient($scope.client)
					.subscribe(
						data => successAddClient(data),
						error => errorAddClient(error.data),
						() => ($scope.isCreateClientModalSpinnningWheelActive = false)
					);
			} else {
				toastr.error(
					'Please fill at least "Email" and "First Name" fields to save client profile',
					'Error'
				);
				$scope.isCreateClientModalSpinnningWheelActive = false;
			}
		};

		function successUpdateClient(data) {
			if (data.errorMessage) {
				messageService.showToaster('e_2', 'general', data.errorMessage);
			} else {
				toastr.success('Client details have been updated!', 'Success');
				$('#createNewClientModal').modal('hide');
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}
		}

		function successAddClient(data) {
			if (data.errorMessage) {
				messageService.showToaster('e_2', 'general', data.errorMessage);
			} else {
				messageService.showToaster('s_2', 'clients');
				$('#createNewClientModal').modal('hide');
				$scope.client = {};
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}
		}

		function errorAddClient(data) {
			if (
				data.errorMessage ===
				'Sorry, this customer has been deleted on QuickBooks'
			) {
				messageService.showToaster('e_23', 'qb');
			} else {
				messageService.showToaster('e_6', 'clients');
			}
			$scope.isCreateClientModalSpinnningWheelActive = false;
		}

		$scope.showDeleteModal = id => {
			$scope.contactForDelete = id;
			$scope.checkForDelete();
		};

		$scope.checkForDelete = () => {
			$scope.button_disable = true;
			clientsDataService
				.checkBeforeDelete($scope.contactForDelete)
				.finally(() => {
					$scope.button_disable = false;
				})
				.subscribe(
					() => $('#deleteModal').modal('show'),
					result => {
						if (result.error && result.error.errorCode) {
							$scope.clientDeleteErrorMessage = result.error.errorMessage;
							$('#errorMessageModal').modal('show');
						} else {
							messageService.showDefaultErrorMessage(result);
						}
					}
				);
		};
		$scope.getElement = function(index) {
			const tableId = document
				.getElementById('tableId')
				.getBoundingClientRect();
			const dotsMenu = document
				.getElementById(`dotsMenuClient-${index}`)
				.getBoundingClientRect();
			const add = document.getElementsByClassName(
				`dropdown-menu-client-${index}`
			);
			add[0].style.transform = '';
			// 122-height of modal; 30-height of 3 dots menu 149-height of 1 row
			const x = dotsMenu.top - tableId.top;
			let value = tableId.height - x;
			if (tableId.height > 149 && value < 122) {
				value -= 30;
				add[0].style.transform = `translate(-20%, ${value}px)`;
			}
		};
		$scope.deleteContact = () => {
			$scope.isDeleteContactSpinnningWheelActive = true;
			clientsDataService
				.deleteClient($scope.contactForDelete)
				.finally(() => {
					$scope.isDeleteContactSpinnningWheelActive = false;
				})
				.subscribe(
					data => {
						if (data.errorMessage) {
							$('#deleteModal')
								.modal('hide')
								.on('hidden.bs.modal', function() {
									$scope.clientDeleteErrorMessage = data.errorMessage;
									$('#errorMessageModal').modal('show');
									$(this).off('hidden.bs.modal');
								});
						} else {
							messageService.showToaster('s_0', 'clients');

							$('#deleteModal').modal('hide');
							getResultsPage(
								$scope.pageRequest.page,
								$scope.pageRequest.perPage
							);
						}
					},
					() => {
						toastr.error('Request to server failed!', 'Error');
					}
				);
		};

		function getResultsPage(
			pageNumber = null,
			perPage = null,
			predicate = null,
			reverse = null
		) {
			let changed = false;

			if (predicate) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = !!reverse;
				changed = true;
			}
			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}
			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				$scope.pageRequest.page = 1;
			}
			('');
			if (changed) {
				clientsDataService
					.getClientsOnPage($scope.pageRequest, '')
					.subscribe(
						data => successGetResultsPage(data),
						error => messageService.showDefaultErrorMessage(error)
					);
			}
		}

		function successGetResultsPage(data) {
			if (!data) return;

			if (data && data.pageRequest) {
				('');
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.searchText;
			}

			$scope.totalItems = data ? data.total : 0;

			let pagesCount;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			const temp = [];
			for (let i = 1; i <= pagesCount; i++) {
				temp.push(i);
			}
			$scope.pageNumbers = angular.copy(temp);
			$scope.contacts = angular.copy(data.results);
		}
	};

	ClientsController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$routeParams',
		'authTokensService',
		'clientsDataService',
		'messageService',
		'validationService',
		'templateRequestsService',
		'mailsDataService',
		'emailService',
		'fileDownloadDataService',
		'settingsService'
	];

	angular.module('main').controller('ClientsController', ClientsController);
})();



// WEBPACK FOOTER //
// ./web/js/controllers/clientsController.js